/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Warehouse_No_Pending_OrdersInputs */

const vi_dashboard_warehouse_no_pending_orders = /** @type {(inputs: Dashboard_Warehouse_No_Pending_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có đơn nào chờ xuất kho.`)
};

/**

* @param {Dashboard_Warehouse_No_Pending_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_warehouse_no_pending_orders = /** @type {((inputs?: Dashboard_Warehouse_No_Pending_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Warehouse_No_Pending_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_warehouse_no_pending_orders(inputs)
});